import 'slick-carousel'
import GET_ARTICLES from '../plugins/getArticles'
// import GOOGLEMAP from '../plugins/googlemap'

const [ w, d ] = [ window, document ]

const init = () => {
  // map script
  // const km = w.siteinfo.mapApiKeys
  // const env_map_key = (!km[host]) ? km['local'] : km[host]
  // w.addScript({src:`https://maps.googleapis.com/maps/api/js?v=3&key=${env_map_key}&callback=load.mapScript.resolve`})
  
  // メインビジュアル
  w.load['mainvisual'].then( () => {
    // slick
    $('[data-plugin="slider"]').slick({
      autoplay:true,
      fade: true,
      arrows: false,
      dots: false,
      speed: 1200,
      autoplaySpeed: 4000,
      pauseOnHover: false,
      pauseOnFocus: false,
    })
  })

  //ticker
  $.when( w.load['block-ticker'] ).then( () => {
    let makeItem = item => $(`
      <a href="${item.href}" class="link">
        <span class="cat">${item.category.name}</span>
        <span class="date">${item.date}</span>
        <span class="subject">${item.title}</span>
      </a>
    `)[0]
    GET_ARTICLES( '.ticker__article[data-plugin="getArticles"]', { makeItem })
  })
  
  // recommend
  $.when( w.load['block-recommendation'] ).then( () => {
    let makeItem = item => $(`
      <a href="${item.href}" class="recommend-item">
        <figure class="recommend-item__img">
          <div class="recommend-item__img-cover"><img src="${item.thumb}" alt="${item.title}" width=""></div>
        </figure>
        <div class="recommend-item__body">
          ${item.is_new ? '<span class="new">NEW</span>': ''}
          <span class="cat">${item.category.name}</span>
          <h4 class="name">${item.title}</h4>
          <p class="desc">${item.desc}</p>
        </div>
      </a>
    `)[0]
    GET_ARTICLES('.block-recommend__list[data-plugin="getArticles"]',{ makeItem })
  })
  
  // news
  $.when( w.load['block-news'] ).then( () => {
    let makeItem = item => $(`
      <a href="${item.href}" class="news-item">
        <figure class="news-item__img">
          <div class="news-item__img-cover"><img src="${item.thumb}" alt="${item.title}" width=""></div>
        </figure>
        <div class="news-item__body">
          <span class="cat">${item.category.name}</span>
          <span class="date">${item.date}</span>
          ${item.is_new ? '<span class="new">NEW</span>': ''}
          <h4 class="subject">${item.title}</h4>
        </div>
      </a>
    `)[0]
    GET_ARTICLES('.block-news__list[data-plugin="getArticles"]',{ makeItem })
  })
  
  // map
  // document.addEventListener( 'DOMContentLoaded', () => {
  //   $.when(
  //     w.load['mapScript'],
  //     w.load['contentFooter']
  //   ).done( () => GOOGLEMAP() )
  // } )
}

export default function HOME() {

  $(() => init() );

}